/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import { RouterV2Enum } from '@/router/router-names';
import { namespace } from 'vuex-class';
import style from './index.module.scss';

let timer: NodeJS.Timeout | null = null;

const HomeStore = namespace('home');

@Component({ name: 'UserCenterFloat' })
export default class UserCenterFloat extends Vue {
  @HomeStore.State advHomeFloatHasVisible!: boolean;

  /** 是否显示首页客服浮窗 */
  private get visibility() {
    return store.state.base.isHybridAppMode;
  }

  /** 是否滚动开始 */
  private isScrollStart = false;

  private mounted() {
    window.addEventListener('scroll', this.handleScrollBind);
  }

  private beforeDestroy() {
    window.removeEventListener('scroll', this.handleScrollBind);
  }

  private handleScroll() {
    if (!this.isScrollStart) {
      this.isScrollStart = true;
    }
    if (timer) {
      clearTimeout(timer);
    }
    /** 用户结束页面滚动后延迟展示浮标，与浮标动效有关 */
    timer = setTimeout(() => {
      this.isScrollStart = false;
    }, 1500);
  }

  private handleScrollBind = this.handleScroll.bind(this);

  private onClickEnterFloat() {
    this.$router.push(RouterV2Enum.myProfile);
  }

  private render() {
    if (this.visibility) {
      return (
        <div
          class={[
            style.enterCenterFloat,
            this.isScrollStart && style.startAnimation,
            /** 首页右下角浮标与广告位位置有重叠，往上偏移一定px */
            this.advHomeFloatHasVisible && style.offsetLocation,
          ]}
          onClick={() => this.onClickEnterFloat()} />
      );
    }

    return null;
  }
}
